<script setup lang="ts">
import type { PartnerModel } from '@/types/partners/PartnerModel'
import { CreateButton, IconItem } from '@rfc/rfc-components-library'
import { EColors } from '@rfc/rfc-components-library/types'
import { useWindowSize } from '@vueuse/core'
import { computed, ref } from 'vue'
import EventCreateCheckpointDialog from './EventCreateCheckpointDialog.vue'

type Props = {
    eventId: number
    partnerConfig?: PartnerModel
    loading?: boolean
}
defineProps<Props>()
const emit = defineEmits<{ (e: 'refresh'): void }>()

const createCheckpointOpen = ref(false)
const handleDialogOpen = (value: boolean) => (createCheckpointOpen.value = value)

const refresh = () => {
    createCheckpointOpen.value = false
    emit('refresh')
}
const { width } = useWindowSize()
const isCompactView = computed(() => width.value < 1108)
</script>

<template>
    <CreateButton
        v-if="!isCompactView"
        :loading="loading"
        :label="$t('event.button.addCheckpoint')"
        @click="handleDialogOpen(true)"
        class="anim-btn"
        v-bind="$attrs" />
    <div
        v-else
        :loading="loading"
        @click="handleDialogOpen(true)"
        class="inline-flex items-center justify-center bg-orange-500 text-white px-3 py-1 rounded-lg hover:bg-orange-600 duration-300 ease-in-out cursor-pointer"
        v-bind="$attrs">
        <IconItem icon="plus" :type="EColors.WHITE" />
    </div>
    <EventCreateCheckpointDialog
        :open="createCheckpointOpen"
        :eventId="eventId"
        :partnerConfig="partnerConfig"
        @refresh="refresh"
        @close="handleDialogOpen(false)" />
</template>

<style scoped lang="scss"></style>
